import { SyncableStatus } from "../../../core/database/db";

export enum VendorDeliveryState {
  NoVendorAssigned = "no-vendor-assigned",
  ContactRequired = "contact-required",
  NotSent = "not-sent",
  Sent = "sent",
  Viewed = "viewed"
}

export const VENDOR_DELIVERY_FILTER_OPTIONS: VendorDeliveryState[] = [
  VendorDeliveryState.NoVendorAssigned,
  VendorDeliveryState.ContactRequired,
  VendorDeliveryState.NotSent,
  VendorDeliveryState.Sent,
  VendorDeliveryState.Viewed
];


export interface JobIssueVendorDTO {
  issueVendorIdentifier: string;
  externalVendorId: number;
  issueIdentifier: string;
  updatedAt: Date;
  createdAt: Date;
  deleted?: boolean;
  isSent: boolean;
  viewedAt?: Date;
  lastSentAt?: Date;
  vendorName?: string;
}

export type JobIssueVendorDTOSyncable = JobIssueVendorDTO & {
  syncStatus: SyncableStatus;
}
